module.exports = __webpack_public_path__ + "img/abc-jazz.e9ca7fe5.png";